import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from '@mui/material';
import {useTranslation} from "react-i18next";

const ConfirmationDialog = ({open, title = 'Confirm', message = 'Are you sure?', onConfirm, onCancel}) => {
    const {t} = useTranslation()
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="inherit">
                    {t("Cancel")}
                </Button>
                <Button onClick={onConfirm} color="primary" variant="contained">
                    {t("Confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
